import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { WithReset } from "src/sudokit/Layout/BoxReset";

type MentionSuggestionsContainerProps = {
  children?: React.ReactNode;
  onVisibilityChange?: (visible: boolean) => void;
};

export function MentionSuggestionsContainer({ children, onVisibilityChange }: MentionSuggestionsContainerProps) {
  const hasChildren = React.Children.count(children) > 0;

  React.useEffect(() => {
    onVisibilityChange?.(hasChildren);
  }, [hasChildren, onVisibilityChange]);

  return (
    <AnimatePresence>
      {hasChildren && (
        <WithReset>
          <motion.div
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="bg-app-menu-color backdrop-blur-xl shadow-card border border-solid border-app-menu-color-hover rounded-xl overflow-hidden p-2"
          >
            {children}
          </motion.div>
        </WithReset>
      )}
    </AnimatePresence>
  );
}
